import {Pagination, Table, Tag} from "antd";
import SupplierAction from "./SupplierAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import {renderDate} from "../../../../utils";

function SupplierTable({items = [], pagination, onPaginationChange, setItemEdit, openModal, handleStatus, can}) {

	const {tableHeight} = useContext(AppContext);

	let columns = [
		{ title: 'Code', dataIndex: 'code', key: "code", width: '100px', render: (_, item) => (
			<div><b>{item?.code}</b></div>
		)},
		{ title: 'Name', dataIndex: 'name', key: "name", width: '200px', render: (_, item) => (
			<div><span>{item.name}</span></div>
		)},
		{ title: 'Liên hệ', dataIndex: 'contact', key: "contact", width: '200px', render: (_, item) => (
			<div>
				<p>{item?.phone}</p>
				<p>{item?.email}</p>
			</div>
		)},
		{ title: 'Địa chỉ', dataIndex: 'address', key: "address", width: '200px', render: (_, item) => (
			<span>{item.address}</span>
		)},
		{
			title: 'Ngày ký HĐ',
			dataIndex: 'contractDate',
			key: "contractDate",
			width: '120px', render: (_, item) => (item?.contractDate ? renderDate(item?.contractDate) : '--')
		},
		{
			title: 'Hết hạn HĐ',
			dataIndex: 'expireDate',
			key: "expireDate",
			width: '130px', render: (_, item) => (item?.expireDate ? renderDate(item?.expireDate) : '--')
		},
		{ title: 'Note', dataIndex: 'note', key: "note", width: '100px', render: (_, item) => (
			<span>{item.note}</span>
		)},

		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<SupplierAction key={item.id}
                            item={item}
                            setItemEdit={setItemEdit}
                            openModal={openModal}
                            can={can}
			/>
		)},
	];


	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table
					columns={columns}
					dataSource={dataSource}
					scroll={{ y:tableHeight, x: 'max-content' }}
					pagination={false}
				/>
			</div>
			<Pagination current={pagination?.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination?.limit} total={pagination?.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default SupplierTable;